import { Progress } from '@volkswagen-onehub/components-core';
import { ComponentProps, ComponentType } from 'react';
import styled from 'styled-components';

export const StyledErrorContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 70vh;
	width: 100%;

	@media (min-width: 375px) {
		padding-left: var(--size-grid002);
		padding-right: var(--size-grid002);
	}
	@media (min-width: 560px) {
		padding-left: var(--size-grid004);
		padding-right: var(--size-grid004);
	}

	@media (min-width: 960px) {
		padding-left: var(--size-grid006);
		padding-right: var(--size-grid006);
	}

	@media (min-width: 1280px) {
		padding-left: var(--size-grid007);
		padding-right: var(--size-grid007);
	}

	@media (min-width: 1600px) {
		padding-left: var(--size-grid008);
		padding-right: var(--size-grid008);
	}

	@media (min-width: 1920px) {
		padding-left: var(--size-grid008);
		padding-right: var(--size-grid008);
	}
`;

export const StyledProgressContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 70vh;
	width: 100%;

	@media (min-width: 375px) {
		padding-left: var(--size-grid002);
		padding-right: var(--size-grid002);
	}
	@media (min-width: 560px) {
		padding-left: var(--size-grid004);
		padding-right: var(--size-grid004);
	}

	@media (min-width: 960px) {
		padding-left: var(--size-grid006);
		padding-right: var(--size-grid006);
	}

	@media (min-width: 1280px) {
		padding-left: var(--size-grid007);
		padding-right: var(--size-grid007);
	}

	@media (min-width: 1600px) {
		padding-left: var(--size-grid008);
		padding-right: var(--size-grid008);
	}

	@media (min-width: 1920px) {
		padding-left: var(--size-grid008);
		padding-right: var(--size-grid008);
	}
`;

export const StyledSVGContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	padding-bottom: var(--size-dynamic0200);

	svg {
		display: block;
		margin: 0 auto;
		height: auto;
		@media (min-width: 375px) {
			width: 187px;
		}
		@media (min-width: 560px) {
			width: 187px;
		}

		@media (min-width: 960px) {
			width: 240px;
		}

		@media (min-width: 1280px) {
			width: 240px;
		}

		@media (min-width: 1600px) {
			width: 266px;
		}

		@media (min-width: 1920px) {
			width: 320px;
		}
	}
`;

export const Message = styled.div`
	position: absolute;
	top: calc(50% + 40px);
	left: 50%;
	transform: translateX(-50%);
`;

type ProgressComponentProps = ComponentProps<typeof Progress>;
export const StyledProgress: ComponentType<ProgressComponentProps> = styled(Progress)`
	width: 100%;
`;
